import { render, staticRenderFns } from "./MeetingSummaryFunction.vue?vue&type=template&id=601a4ab1"
import script from "./MeetingSummaryFunction.vue?vue&type=script&lang=js"
export * from "./MeetingSummaryFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports